import { Component, OnInit, ContentChild } from "@angular/core";
import { NgbActiveModal, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { UserProductService, UserProductPostPut } from "../../../api";
import { CustomdatepickerComponent } from "../../../../shared/modules/customdatepicker.component";
import { compressImage } from "../../../../shared/service/image.service";

@Component({
  selector: "app-bike",
  templateUrl: "./bike.component.html",
  styleUrls: ["./bike.component.scss"],
})
export class BikeComponent implements OnInit {
  @ContentChild(CustomdatepickerComponent)
  customDatepicker: CustomdatepickerComponent;

  bikeForm: FormGroup;
  products = [];
  productsSelect = [];
  categories = [];
  brands = [];
  places = [];
  framePhotos: string[] = [];
  billPhotos: string[] = [];
  serialPhotos: string[] = [];
  data: UserProductPostPut = <UserProductPostPut>{};
  shop = null;
  customer;
  showSerial = false;
  constructor(
    public activeModal: NgbActiveModal,
    private ups: UserProductService
  ) {}

  ngOnInit() {
    const today = new Date();
    let date = {
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      day: today.getDate(),
    };
    this.ups
      .apiUserProductsBrandCategoryProductSelectGet(true)
      .subscribe((data) => {
        this.brands = data.brandRepairshops;
        this.categories = data.categories;
        this.products = data.products;
        this.filterBike();
        if (this.data) {
          this.brand.setValue(this.data.product.brandId);
          this.productsSelect = this.products.filter(p =>
            p.brandId === this.brand.value
          );
      
          const selectedProduct = this.productsSelect.find(
            (o) => o.productId === this.data.product.productId
          );
          this.bike.setValue(selectedProduct);
          if (this.bike.value.showSerialNumber) {
            this.showSerial = true;
            this.serial.setValidators([Validators.required]);
          }
          this.category.setValue(this.data.categoryId);
          this.frame.setValue(this.data.frameNumber);
          this.serial.setValue(this.data.serialNumber);
          this.bill.setValue(this.data.billNumber);
          this.place.setValue(
            this.places.find(
              (o) =>
                this.data.purchasedPlaceId &&
                o.repairshopId == this.data.purchasedPlaceId
            )
          );
          if (this.data.billDate) {
            const dt = new Date(this.data.billDate * 1000);
            this.date.setValue({
              year: dt.getFullYear(),
              month: dt.getMonth() + 1,
              day: dt.getDate(),
            });
          }
          this.selectBike();
        }
      });

    this.bikeForm = new FormGroup({
      brand: new FormControl(),
      category: new FormControl(),
      bike: new FormControl(null, [Validators.required]),
      frame: new FormControl(null, [Validators.required]),
      serial: new FormControl(null, [Validators.required]),
      date: new FormControl(date),
      place: new FormControl(null, [Validators.required]),
      bill: new FormControl(),
    });
    if (this.data) {
      if (this.data.billPhoto) this.billPhotos = [this.data.billPhoto];
      this.framePhotos = this.data.framePhotos;
      this.serialPhotos = this.data.serialPhotos;
    }
  }

  get brand() {
    return this.bikeForm.get("brand");
  }
  get category() {
    return this.bikeForm.get("category");
  }
  get bike() {
    return this.bikeForm.get("bike");
  }
  get frame() {
    return this.bikeForm.get("frame");
  }
  get bill() {
    return this.bikeForm.get("bill");
  }
  get serial() {
    return this.bikeForm.get("serial");
  }
  get place() {
    return this.bikeForm.get("place");
  }
  get date() {
    return this.bikeForm.get("date");
  }

  validateForm(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateForm(control);
      }
    });
  }
  uploadFileFramePhotos(e: any) {
    this.framePhotos = [];
    this.uploadFiles(e, this.framePhotos);
  }
  uploadFileBillPhotos(e: any) {
    this.billPhotos = [];
    this.uploadFiles(e, this.billPhotos);
  }
  uploadSerialPhotos(e: any) {
    this.serialPhotos = [];
    this.uploadFiles(e, this.serialPhotos);
  }

  uploadFiles(e: any, photos: string[]) {
    let files = e.target.files,
      filesLength = files.length;
    // Ảnh khung/số serial/hoá đơn được nhúng vào email báo giá, nơi Outlook
    // không đọc được WebP, nên chỉ thu nhỏ và nén lại ở dạng JPEG.
    //
    // Nén là bất đồng bộ nên đọc xong toàn bộ rồi mới đẩy vào mảng một lượt,
    // như vậy thứ tự đúng với lúc người dùng chọn và khung ảnh không hiện ô
    // rỗng ở giữa chừng.
    const jobs: Promise<string>[] = [];
    for (let i = 0; i < filesLength; i++) {
      let f = files[i];
      jobs.push(
        compressImage(f, "jpeg").then(
          (compressed) =>
            new Promise<string>((resolve) => {
              let fileReader = new FileReader();
              fileReader.onload = (ev: any) =>
                resolve(ev.target.result.toString());
              fileReader.readAsDataURL(compressed);
            })
        )
      );
    }
    Promise.all(jobs).then((results) =>
      results.forEach((r) => photos.push(r))
    );
    return photos;
  }

  removeFramePhoto(img: string) {
    this.framePhotos = this.framePhotos.filter((o) => o != img);
    // this.framePhotosAddNew = this.framePhotosAddNew.filter(
    //   (o) => o.dataFile != img
    // );
  }
  removeSerialPhoto(img: string) {
    this.serialPhotos = this.serialPhotos.filter((o) => o != img);
  }
  removeBillPhoto(img: string) {
    this.billPhotos = this.billPhotos.filter((o) => o != img);
  }
  chooseFile(control: string) {
    document.getElementById(control).click();
  }
  selectBrand(item) {
    this.shop = null;
    // this.places = item.purchasedPlaces;
    this.filterBike();
  }
  selectBike() {
    this.brand.setValue(this.bike.value.brandId);
    this.category.setValue(this.bike.value.categoryId);
    if (this.bike.value.showSerialNumber) {
      this.showSerial = true;
      this.serial.setValidators([Validators.required]);
    } else {
      this.showSerial = false;
      this.serial.clearValidators();
    }
    this.serial.updateValueAndValidity();
  }
  filterBike() {
    let list = [];
    this.bike.setValue(null);
    if (!this.brand.value && !this.category.value) {
      list = this.products;
    } else {
      this.products.forEach((element) => {
        if (this.brand.value && this.category.value) {
          if (
            element.brandId === this.brand.value &&
            element.categoryId === this.category.value
          ) {
            list.push(element);
          }
        }
        if (this.brand.value && !this.category.value) {
          if (element.brandId === this.brand.value) {
            list.push(element);
          }
        }
        if (!this.brand.value && this.category.value) {
          if (element.categoryId === this.category.value) {
            list.push(element);
          }
        }
      });
    }
    this.productsSelect = list;
  }
  closeModal() {
    this.activeModal.dismiss("close");
  }
  saveModal() {
    if (this.bikeForm.valid) {
      // Lấy ngày từ datepicker và convert sang Unix timestamp (giây)
      const selectedDate = this.date.value;
      const billDate = new Date(
        selectedDate.year,
        selectedDate.month - 1,
        selectedDate.day
      );
      billDate.setHours(12);
      const unixTimestamp = Math.floor(billDate.getTime() / 1000);

      if (!this.data) this.data = <UserProductPostPut>{};
      this.data.productId = this.bike.value.productId;
      this.data.frameNumber = this.frame.value;
      this.data.serialNumber = this.serial === null ? "" : this.serial.value;
      this.data.billDate = unixTimestamp;
      this.data.billNumber = this.bill === null ? "" : this.bill.value;
      this.data.purchasedPlaceId = this.place.value.repairshopId;
      this.data.framePhotos = this.framePhotos;
      this.data.serialPhotos = this.serialPhotos;
      this.data.billPhoto =
        this.billPhotos.length > 0 ? this.billPhotos[0] : "";
      this.data.customerId = this.customer.customerId;
      this.data.bikeType = "Normal";
      this.data.type = this.place.value.type;
      this.data.product = this.bike.value;
      this.data.product.name = this.bike.value.productName;
      this.data.product.brand = { brandId: this.brand.value };
      this.data.product.type = "Bicycle";

      if (!this.data.userProductId) {
        this.ups.apiUserProductsPost(this.data).subscribe(() => {
          this.activeModal.close();
        });
      } else {
        this.ups
          .apiUserProductsUserProductsCasePostPost(this.data)
          .subscribe(() => {
            this.activeModal.close();
          });
      }
    } else {
      this.validateForm(this.bikeForm);
    }
  }
}
